import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../lib/api';
import PageRenderer from '../components/PageRenderer';
import usePageMeta from '../hooks/usePageMeta';

export default function GenericPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setPage(null); setErr(null);
    api.get(`/api/pages/${slug}`)
      .then(({ data }) => setPage(data))
      .catch((e) => setErr(e.message));
  }, [slug]);

  const seo = useMemo(() => {
    if (!page) return { title: slug };
    const blocks = page.blocks || [];
    const hero = blocks.find((b) => b?.type === 'section_hero') || {};
    const firstParagraph = blocks.find((b) => b?.type === 'paragraph') || {};
    return {
      title: page.meta_title || page.title || slug,
      description:
        page.meta_description ||
        hero.subtitle ||
        firstParagraph.text ||
        'The Elemental Embrace.',
      image: page.meta_image || hero.image_src || undefined,
      type: 'article',
    };
  }, [page, slug]);

  usePageMeta(seo);

  if (err) return <div className="min-h-[60vh] flex items-center justify-center text-center"><div><div className="text-gold text-xl mb-2">Page not found</div><div className="text-ee-muted text-sm">{err}</div></div></div>;
  if (!page) return <div className="min-h-[60vh] flex items-center justify-center"><div className="h-10 w-10 rounded-full border-2 border-gold/30 border-t-gold animate-spin" /></div>;
  return <PageRenderer blocks={page.blocks || []} />;
}
